/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Dialect_Hint_Ebrana_Getuser_XmlInputs */

const cs_import_dialect_hint_ebrana_getuser_xml = /** @type {(inputs: Import_Dialect_Hint_Ebrana_Getuser_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorázová migrace makléřů z GetUserStamps.php / GetUser.php. Páruje existující uživatele CRM podle export id nebo e-mailu; vytváří jen nespárované.`)
};

const en_import_dialect_hint_ebrana_getuser_xml = /** @type {(inputs: Import_Dialect_Hint_Ebrana_Getuser_XmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time broker (makléř) migration from GetUserStamps.php / GetUser.php. Matches existing CRM users by export id or email; creates brokers only when unmatched.`)
};

/**
* | output |
* | --- |
* | "One-time broker (makléř) migration from GetUserStamps.php / GetUser.php. Matches existing CRM users by export id or email; creates brokers only when unmatched." |
*
* @param {Import_Dialect_Hint_Ebrana_Getuser_XmlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_dialect_hint_ebrana_getuser_xml = /** @type {((inputs?: Import_Dialect_Hint_Ebrana_Getuser_XmlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Dialect_Hint_Ebrana_Getuser_XmlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_dialect_hint_ebrana_getuser_xml(inputs)
	return cs_import_dialect_hint_ebrana_getuser_xml(inputs)
});